import { useRoute } from '#imports'

import * as landingReviewsAPI from '@backmarket/http-api/src/api-specs-reviews/landing-reviews'
import * as productReviewsAPI from '@backmarket/http-api/src/api-specs-reviews/product-reviews'
import * as reviewsAPI from '@backmarket/http-api/src/api-specs-reviews/reviews'
import * as sellerReviewsAPI from '@backmarket/http-api/src/api-specs-reviews/seller-reviews'

import { PRODUCT_ROUTES } from '~/scopes/product-core/route-names'
import { ROUTES as PRODUCT_LIST_ROUTES } from '~/scopes/product-list/route-names'

import { ROUTES } from '../../route-names'

export function useRequests() {
  const route = useRoute()

  switch (route.name) {
    case PRODUCT_ROUTES.MASTER_PRODUCT_PAGE:
    case PRODUCT_ROUTES.VARIANT_PRODUCT_PAGE:
      return {
        ...productReviewsAPI,
        headers: { 'BM-Page-Name': route.name },
        hasAIReviewsSummary: true,
      }
    case PRODUCT_LIST_ROUTES.PRODUCT_LIST:
      return { ...landingReviewsAPI }
    case PRODUCT_LIST_ROUTES.SELLER_PRODUCT_LIST:
      return { getReviews: sellerReviewsAPI.getReviews }
    case ROUTES.PAGES.ALL:
    case ROUTES.PAGES.BATTERY:
      return reviewsAPI

    default:
      return undefined
  }
}
